<template>
  <div>
    <div v-if="canEdit" class="mb-2 d-block d-md-flex justify-content-end">
      <b-input
        v-model="rolesSearch"
        placeholder="Search roles..."
        type="search"
        size="sm"
      />
      <b-btn
        v-b-modal.add-role
        class="ml-2 shrink-0"
        size="sm"
        variant="primary"
      >
        <i class="icon-plus" /> Add Role
      </b-btn>
    </div>

    <b-table :fields="tableFields" :items="roles" :filter="rolesSearch">
      <template #cell(name)="{ item }">
        {{ item.name }}
      </template>
      <template #cell(description)="{ item }">
        {{ item.description }}
      </template>
      <template #cell(count)="{ item }">
        {{ item.users.length }}
      </template>
      <template #cell(actions)="{ item }">
        <b-btn
          v-if="!defaultRoles.includes(item.name)"
          v-b-tooltip.hover="'Delete role'"
          class="py-0 px-2"
          variant="link"
          @click="deleteRole(item)"
        >
          <i class="icon-trash text-danger" />
        </b-btn>
      </template>
    </b-table>

    <OrgCreateRoleModal
      :org-id="org.id"
      @updated="
        loadRoles();
        $emit('updated');
      "
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import API from "@/api";

import OrgCreateRoleModal from "@/components/organizations/OrgCreateRoleModal.vue";

export default {
  components: {
    OrgCreateRoleModal
  },

  props: {
    org: Object,
    canEdit: Boolean
  },

  data: () => ({
    defaultRoles: ["Owner", "Admin", "User", "Collab"],
    roles: [],
    rolesSearch: ""
  }),

  computed: {
    ...mapState(["user"]),

    tableFields() {
      const fields = [
        { key: "name", label: "Name", sortable: true },
        { key: "description", label: "Description" },
        { key: "count", label: "Members", sortable: true },
        { key: "actions", label: "Actions", class: "text-center" }
      ];

      if (!this.canEdit) {
        fields.pop();
      }

      return fields;
    }
  },

  watch: {
    org: {
      handler: "loadRoles",
      immediate: true
    }
  },

  methods: {
    async loadRoles() {
      const { results } = await API.getOrgRoles(this.org.id);
      this.roles = results;
    },

    async deleteRole(role) {
      const confirm = await this.$bvModal.msgBoxConfirm(
        `Are you sure you want to delete the role "${role.name}"?`,
        {
          title: "Delete Role",
          okTitle: "Delete",
          okVariant: "danger",
          size: "sm",
          centered: true
        }
      );
      if (!confirm) return;

      const { success } = await API.deleteOrgRole(this.org.id, role.id);
      if (!success) return;

      this.$emit("updated");
      this.$notify({
        type: "success",
        text: `Role "${role.name}" deleted`
      });
    }
  }
};
</script>
